import React from "react";
import IrctcAddressChangeV2 from "./IrctcAdressV2";
import { IrctcAddressChangeProps } from "./type";

const IrctcAddressChangeComp: React.FC<IrctcAddressChangeProps> = ({
    irctcData,
    trainOrderAttributes,
    editHandler,
    onImpressionIrctcUpdateAddress,
    selectedAddress,
    hideEditCta,
}) => {
    return (
        <IrctcAddressChangeV2
            irctcData={irctcData}
            trainOrderAttributes={trainOrderAttributes}
            editHandler={editHandler}
            onImpressionIrctcUpdateAddress={onImpressionIrctcUpdateAddress}
            selectedAddress={selectedAddress}
            hideEditCta={hideEditCta}
        />
    );
};

const IrctcAddressChange = React.memo(IrctcAddressChangeComp);
export { IrctcAddressChange };
